import React from 'react'
import { useNavigate, useLocation } from "react-router-dom"
import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarSeparator,
    Button
} from "../shadcnComponents/ui"
import { Home } from "lucide-react"

export function GeneralSideBar(props) {
    const navigate = useNavigate();
    // const [location, setLocation] = useState('')
    const location = useLocation()
    function handleNavigateToHome() {
        if (location.pathname == '/home') {
            if (document.getElementById('location0')) {
                document.getElementById('location0').click()
            }
        } else {
            navigate('/home')
        }
    }
    return (
        <Sidebar>
            <SidebarContent>
                {/* Navigation */}
                <div className='p-3 flex flex-row items-center justify-start'>
                    <Button variant="ghost" size="icon" onClick={() => { handleNavigateToHome('/home') }}>
                        <Home className='size-6' />
                    </Button>
                </div>
                <SidebarSeparator className='mb-3 w-full' />
                <SidebarGroup className='h-fit pb-6 mb-auto'>
                    <SidebarGroupContent className='flex flex-col h-fit gap-4'>
                        <Button variant="sideBar" size="lg" onClick={() => { location.pathname == '/myFiles' ? () => { } : navigate('/myFiles') }}>
                            Τα αρχεία μου
                        </Button>
                        <Button variant="sideBar" size="lg" onClick={() => { location.pathname == '/home' ? () => { } : navigate('/home') }}>
                            Πρόσφατα αρχεία
                        </Button>
                        {props.admin &&
                            <Button variant="sideBar" size="lg" onClick={() => { location.pathname == '/groupManagement' ? () => { } : navigate('/groupManagement') }}>
                                Διαχείριση χρηστών και ομάδων
                            </Button>
                        }
                    </SidebarGroupContent>
                </SidebarGroup>
                <SidebarSeparator className='w-full' />
                <SidebarGroup className='h-fit pb-14 pt-10'>
                    <SidebarGroupContent className='flex flex-col h-fit'>
                        <Button variant="secondary" size="lg" className='mx-auto w-9/12' onClick={props.handleLogout}>
                            Αποσύνδεση
                        </Button>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    )
}

export default GeneralSideBar;